// Field utility functions and constants
import { getAuthHeaders } from "./apiUtils";

// Mapping from section dataField to corresponding Fields object in backend
export const SECTION_FIELD_MAPPING = {
  'mental_status_exam': 'mentalStatusFields',
  'social_history': 'socialHistoryFields',
  'psychiatric_history': 'psychiatricHistoryFields',
  'psychiatric_ROS': 'psychiatricROSFields',
  'trauma_history': 'traumaHistoryFields',
  'medical_history': 'pastMedicalHistoryFields',
  'assessment_factors': 'assessmentFactorsFields'
};

// Helper function to determine if a row should be filled with default values
export const shouldFillRow = (row) => (
  row && // Row exists
  row.name && // Has a name field (non-empty row)
  (!row.summary || row.summary.trim() === "") && // Empty summary
  !row.isHistory && // Not history data
  !row.humanAdded // Not user-added content
);

// Helper function to create a filled row with default value
export const createFilledRow = (row, defaultValue) => ({
  ...row,
  summary: defaultValue,
  humanReview: true,
  humanAdded: true,
});

// Cache for field data to avoid repeated API calls
let fieldDataCache = null;
let fieldDataPromise = null;

// Get field data with caching
export const getFieldData = async () => {
  if (fieldDataCache) {
    return fieldDataCache;
  }
  
  if (fieldDataPromise) {
    return fieldDataPromise;
  }
  
  fieldDataPromise = getAuthHeaders().then(headers => fetch("/api/v3/configuration/fields", { headers }))
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    })
    .then(data => {
      fieldDataCache = data.dataFields;
      fieldDataPromise = null;
      return fieldDataCache;
    })
    .catch(error => {
      console.error("Error fetching field data:", error);
      fieldDataPromise = null;
      throw error;
    });
    
  return fieldDataPromise;
};

// Clear cache (useful for testing or when field data changes)
export const clearFieldDataCache = () => {
  fieldDataCache = null;
  fieldDataPromise = null;
};
